import React from 'react';
import Modal from 'react-responsive-modal';
import '../../styles/CustomModal.css';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';

interface InterphoneConfirmModalProps {
  isOpen: boolean;
  modalType: 'confirm' | 'cancel' | 'all';
  title: string;
  description: string;
  onCancelText: string;
  onConfirmText: string;
  onCancel: () => void;
  onConfirm: () => void;
  onClose: () => void;
  icon?: string;
  iconClass?: string;
}

const InterphoneConfirmModal: React.FC<InterphoneConfirmModalProps> = ({
  isOpen,
  modalType,
  title,
  description,
  onCancelText,
  onConfirmText,
  onCancel,
  onConfirm,
  onClose,
  icon,
  iconClass,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      center
      classNames={{
        overlay: 'interphoneConfirmModalOverlay',
        modal: 'interphoneConfirmModal',
      }}
      closeOnOverlayClick={true}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modal">
          <div className="modal_header">
            {icon && <img className={`${iconClass}`} src={icon} alt="icon" />}
            <h3>{title}</h3>
            <h5>{description}</h5>
          </div>
          <div className="modal_footer">
            {modalType !== 'cancel' && (
              <button onClick={() => onConfirm()} className="confirm">
                {onConfirmText}
              </button>
            )}
            {modalType !== 'confirm' && (
              <button onClick={onCancel} className="cancel">
                {onCancelText}
              </button>
            )}
          </div>
        </div>
      </Style>
    </Modal>
  );
};
export default InterphoneConfirmModal;

const Style = styled.div`
  .modal {
    width: 100%;
    padding: 8%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 20px;
    text-align: center;
  }
  .modal_header {
    img,
    h3,
    h5 {
      margin: 8px 0;
    }
    img {
      width: 40px;
      height: 40px;
      padding: 6px;
      border-radius: 100px;
    }
    img.call {
      background: #009712;
      rotate: -135deg;
    }
    h3 {
      font-weight: 600;
      color: #555555;
      white-space: pre-line;
    }
    h5 {
      font-weight: 500;
      color: #979797;
    }
  }

  .modal_footer {
    width: 100%;
    margin-top: auto;
    display: flex;
    align-items: center;
    gap: 10px;
  }
  button {
    flex: 1;
    width: 100%;
    padding: 12px 0;
    border-radius: 10px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 700;
  }
  button.cancel {
    background: #ff6060;
    color: #ffffff;
  }
  button.confirm {
    background: #4dd2ae;
    color: #ffffff;
  }
`;
